export default (state) => {
    return state.appState.locale;
};
